import Pqp from "../../../3x1010/Pqp.js";
import Bout from "../../bout/Bout.js";
import Helper from "../../utils/helper/Helper.js";

export default class Stats {
	constructor() {
		this.checkUpd = new Object();
		this.ids = new Array();
	}

	init() {
		this.mc = jQuery("#template-stats").clone();
		this.mc.attr("id", "stats" + Stats.ENUM++);


		this.build();

	}

	getClip() {
		return this.mc;
	}

	build() {

		let a = [
			"separator|General",
			Bout.STAT_SCORE,
			Bout.STAT_START_TIME,
			"separator|Fights",
			Bout.STAT_ENEMIES_KILLED,
			Bout.STAT_FIGHTS,
			Bout.STAT_ENCOUNTER_NORMAL,
			Bout.STAT_ENCOUNTER_AMBUSH,
			Bout.STAT_ENCOUNTER_SURPRISE,
			"separator|Attacks",
			Bout.STAT_ATTACKS,
			Bout.STAT_HITS,
			Bout.STAT_HITS_CRITICAL,
			Bout.STAT_TOTAL_DAMAGE,
			Bout.STAT_MAX_DAMAGE,
			Bout.STAT_DAMAGE_SUFFERED,
			Bout.STAT_SPIKE_DAMAGE,
			Bout.STAT_PARRIED,
			"separator|Misc",
			Bout.STAT_SECRETS_DISCOVERED,
			Bout.STAT_TORCHES
//			Bout.STAT_CHESTS_OPENED
		]

		for (let x = 0; x < a.length; x++) {
			this.createEntry(a[x]);
		}

		this.update();
	}

	createEntry(id) {
		if (id.indexOf("separator") >= 0) {
			let tmp = jQuery("#template-stat-cat").clone();
			tmp.attr("id", "stacat" + Stats.ENUM++);
			tmp.text(id.split("|")[1]);
			jQuery(".js-list", this.mc).append(tmp);
		} else {
			let tmp = jQuery("#template-stat").clone();
			tmp.attr("id", "stat" + Stats.ENUM++);
			tmp.attr("data-ref", id);
			jQuery(".js-list", this.mc).append(tmp);
			this.ids.push(id);
		}
	}



	update() {
		/*for (let x = 0; x < Stats.Stats.length; x++) {
			let skl = this.player.getSkillValue(Stats.Stats[x].id);
			let plain = this.player.getPlainSkillValue(Stats.Stats[x].id);
			if ((this.checkIfUpdate(Stats.Stats[x].id + "plain", plain)) || (this.checkIfUpdate(Stats.Stats[x].id, skl))) {
				if (skl != plain) {
					jQuery(".js-" + Stats.Stats[x].id, this.mc).html("<span>(" + Helper.toSkill(skl) + ") </span> " + Helper.toSkill(plain));
				} else {
					jQuery(".js-" + Stats.Stats[x].id, this.mc).text(Helper.toSkill(plain));
				}
			}
		}*/
		for (let x = 0; x < this.ids.length; x++) {
			this.updateValue(this.ids[x])
		}

	}

	checkIfUpdate(id, value) {
		if (this.checkUpd[id] !== value) {
			this.checkUpd[id] = value;
			return true;
		}
		return false;
	}

	updateValue(id) {
		let row = this.getRow(id);

		// Score
		if (id === Bout.STAT_SCORE) {
			let value = this.getScore();
			if (this.checkIfUpdate(id, value)) {
				jQuery(".js-name", row).text("Total score");
				jQuery(".js-value", row).text(Helper.toNumber(value));
			}
		}


		// Time played
		if (id === Bout.STAT_START_TIME) {
			let value = this.getElapsedTime();
			if (this.checkIfUpdate(id, value)) {
				jQuery(".js-name", row).text("Time (from the beginning)");
				jQuery(".js-value", row).text(value);
			}
		}

		// Deaths
/*		if (id === Bout.STAT_HERO_DEATHS) {
			let value = Bout.getStatistic(id);
			if (this.checkIfUpdate(id, value)) {
				jQuery(".js-name", row).text("Hero deaths");
				jQuery(".js-value", row).text(value);
			}
		}*/

		// Enemies killed
		if (id === Bout.STAT_ENEMIES_KILLED) {
			let value = Bout.getStatistic(id);
			if (this.checkIfUpdate(id, value)) {
				jQuery(".js-name", row).text("Enemies killed");
				jQuery(".js-value", row).text(value);
			}
		}

		// Total fights
		if (id === Bout.STAT_FIGHTS) {
			let value = Bout.getStatistic(id);
			if (this.checkIfUpdate(id, value)) {
				jQuery(".js-name", row).text("Total fights");
				jQuery(".js-value", row).text(value);
			}
		}

		// Nromal fights
		if (id === Bout.STAT_ENCOUNTER_NORMAL) {
			let value = Bout.getStatistic(id);
			if (this.checkIfUpdate(id, value)) {
				jQuery(".js-name", row).text("Normal encounters");
				jQuery(".js-value", row).text(value);
			}
		}

		// Ambushed fights
		if (id === Bout.STAT_ENCOUNTER_AMBUSH) {
			let value = Bout.getStatistic(id);
			if (this.checkIfUpdate(id, value)) {
				jQuery(".js-name", row).text("Ambushed");
				jQuery(".js-value", row).text(value);
			}
		}

		// Surprise fights
		if (id === Bout.STAT_ENCOUNTER_SURPRISE) {
			let value = Bout.getStatistic(id);
			if (this.checkIfUpdate(id, value)) {
				jQuery(".js-name", row).text("Surprise attacks");
				jQuery(".js-value", row).text(value);
			}
		}

		// Attacks
		if (id === Bout.STAT_ATTACKS) {
			let value = Bout.getStatistic(id);
			if (this.checkIfUpdate(id, value)) {
				jQuery(".js-name", row).text("Total attacks");
				jQuery(".js-value", row).text(value);
			}
		}

		// Hits
		if (id === Bout.STAT_HITS) {
			let value = Bout.getStatistic(id);
			if (this.checkIfUpdate(id, value)) {
				jQuery(".js-name", row).text("Total hits");
				jQuery(".js-value", row).text(value);
			}
		}

		// critical
		if (id === Bout.STAT_HITS_CRITICAL) {
			let value = Bout.getStatistic(id);
			if (this.checkIfUpdate(id, value)) {
				jQuery(".js-name", row).text("Total critical hits");
				jQuery(".js-value", row).text(value);
			}
		}


		// Total damage
		if (id === Bout.STAT_TOTAL_DAMAGE) {
			let value = Bout.getStatistic(id);
			if (this.checkIfUpdate(id, value)) {
				jQuery(".js-name", row).text("Total damage done");
				jQuery(".js-value", row).text(value);
			}
		}

		// Max damage
		if (id === Bout.STAT_MAX_DAMAGE) {
			let value = Bout.getStatistic(id);
			if (this.checkIfUpdate(id, value)) {
				jQuery(".js-name", row).text("Max damage done");
				jQuery(".js-value", row).text(value);
			}
		}

		// damage suf
		if (id === Bout.STAT_DAMAGE_SUFFERED) {
			let value = Bout.getStatistic(id);
			if (this.checkIfUpdate(id, value)) {
				jQuery(".js-name", row).text("Total damage suffered");
				jQuery(".js-value", row).text(value);
			}
		}

		// damage suf
		if (id === Bout.STAT_SPIKE_DAMAGE) {
			let value = Bout.getStatistic(id);
			if (this.checkIfUpdate(id, value)) {
				jQuery(".js-name", row).text("Damage from spikes");
				jQuery(".js-value", row).text(value);
			}
		}


		// damage suf
		if (id === Bout.STAT_PARRIED) {
			let value = Bout.getStatistic(id);
			if (this.checkIfUpdate(id, value)) {
				jQuery(".js-name", row).text("Total parries");
				jQuery(".js-value", row).text(value);
			}
		}


		// torches
		if (id === Bout.STAT_TORCHES) {
			let value = Bout.getStatistic(id) + "/" + Bout.getStatistic(Bout.STAT_TORCHES_TOTAL);
			if (this.checkIfUpdate(id, value)) {
				jQuery(".js-name", row).text("Torches lit");
				jQuery(".js-value", row).text(value);
			}
		}

		// torches
		if (id === Bout.STAT_CHESTS_OPENED) {
			let value = Bout.getStatistic(id) + "/" + Bout.getStatistic(Bout.STAT_CHESTS_TOTAL);
			if (this.checkIfUpdate(id, value)) {
				jQuery(".js-name", row).text("Chests opened");
				jQuery(".js-value", row).text(value);
			}
		}

		// secrets
		if (id === Bout.STAT_SECRETS_DISCOVERED) {
			let value = Bout.getStatistic(id) + "/" + Bout.getStatistic(Bout.STAT_SECRETS_TOTAL);
			if (this.checkIfUpdate(id, value)) {
				jQuery(".js-name", row).text("Secrets discovered");
				jQuery(".js-value", row).text(value);
			}
		}


	}

	getRow(id) {

		let a = jQuery(".js-row", this.mc);
		for (let x = 0; x < a.length; x++) {
			let row = jQuery(a[x])
			if (row.data("ref") === id) {
				return row;
			}
		}
	}


	getElapsedTime() {
		let start = Bout.getStatistic(Bout.STAT_START_TIME);
		let dif = Math.floor(((new Date()).getTime() - start) / 1000);
		let m = Math.floor(dif / 60);
		let s = dif - m * 60;

		return Pqp.padr("" + m, "0", 2) + "m " + Pqp.padr("" + s, "0", 2) + "s";
	}

	getScore() {
		let score = Bout.getStatistic(Bout.STAT_SCORE);
		return score;
	}

}

Stats.ENUM = 0;

